<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel(true)"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Permit Details</h4>
</div>
<div class="modal-body" *ngIf="dataLoaded">
    <fieldset>
        <h2>Customer</h2>
        <p-table [value]="[{}]">
            <ng-template pTemplate="header">
                <tr>
                    <th>Name</th>
                    <th>USDOT#</th>
                    <th>Permit Number</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body">
                <tr>
                    <td>{{pageData.customerDisplayName}}</td>
                    <td>{{pageData.customerUSDOTNumber}}</td>
                    <td>{{pageData.id}}</td>
                </tr>
            </ng-template>
        </p-table>
    </fieldset>
    <fieldset>
        <h2>Load</h2>
        <p-table [value]="[{}]">
            <ng-template pTemplate="header">
                <tr>
                    <th>Description</th>
                    <th>Length</th>
                    <th>Width</th>
                    <th>Height</th>
                    <th>GVM (Lbs)</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body">
                <tr>
                    <td>{{pageData.load.commercialVehicleLoadTypeDisplayValue}}</td>
                    <td>{{pageData.load.length | inches}}</td>
                    <td>{{pageData.load.width | inches}}</td>
                    <td>{{pageData.load.height | inches}}</td>
                    <td>{{pageData.load.grossVehicleWeight}}</td>
                </tr>
            </ng-template>
        </p-table>
    </fieldset>
    <fieldset>
        <h2>Trip - Travel Dates</h2>
        <p-table [value]="[{}]">
            <ng-template pTemplate="header">
                <tr>
                    <th>Trip Type</th>
                    <th>Weekend Travel</th>
                    <th>Effective Date</th>
                    <th>Expiration Date</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body">
                <tr>
                    <td>{{pageData.trip.commercialVehicleTripTypeDisplayValue}}</td>
                    <!-- Field Not Implemented -->
                    <td></td>
                    <td>{{pageData.trip.effectiveDate | shortDate}}</td>
                    <td>{{pageData.trip.expirationDate | shortDate}}</td>
                </tr>
            </ng-template>
        </p-table>
    </fieldset>
    <fieldset>
        <h2>Permit</h2>
        <p-table [value]="[{}]">
            <ng-template pTemplate="header">
                <tr>
                    <th>Type</th>
                    <th>Issue Date</th>
                    <th>Expiration Date</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body">
                <tr>
                    <td>{{pageData.commercialVehiclePermitTypeDisplayValue}}</td>
                    <td>{{pageData.issueDate | shortDate}}</td>
                    <td>{{pageData.expirationDate | shortDate}}</td>
                </tr>
            </ng-template>
        </p-table>
    </fieldset>
</div>
